export default {"src":"/_next/static/media/AMPL.a11f5a9e.svg","height":18,"width":18};